import React, { version, useState, useEffect, useContext } from 'react'
import styled from 'styled-components'
import { useTable, useSortBy, useFilters, useGlobalFilter, useExpanded, useRowSelect, actions } from 'react-table'
import matchSorter from 'match-sorter'
import {Link} from 'react-router-dom'
import { history } from '../../_helpers';
import UserContext from '../../context/context'
// import ReactTable from "react-table";

// import makeData from './makeData'

// import './Table.css'

import {Styles} from './TableStyle_ra'
// import {motion} from 'framer-motion'
// import { withTheme } from '@material-ui/styles'
// import { NONAME } from 'dns'

// const ReactTable = require('react-table');
let current_id = history.location.pathname.split('/')[3]


function GlobalFilter({
    preGlobalFilteredRows,
    globalFilter,
    setGlobalFilter,
  }) {
    const count = preGlobalFilteredRows.length
  
    return (
      <span style={{width: "100%"}}>
        {/* Search:{' '} */}
        <input
          value={globalFilter || ''}
          onChange={e => {
            setGlobalFilter(e.target.value || undefined) // Set undefined to remove the filter entirely
          }}
          placeholder={`${count} records...`}
          style={{
            fontSize: '1.1rem',
            border: '0',
            width: "100%"
          }}
        />
      </span>
    )
  }

export function DefaultColumnFilter({
    column: { filterValue, preFilteredRows, setFilter },
  }) {
    const count = preFilteredRows.length
  
    return (
      <input
        value={filterValue || ''}
        onChange={e => {
          setFilter(e.target.value || undefined) // Set undefined to remove the filter entirely
        }}
        placeholder={`${count} records...`}
        style={{
            width: "100%",
            // maxWidth: "150px"
          }}
      />
    )
  }

function RealDefaultColumnFilter({
    column: { filterValue, preFilteredRows, setFilter },
  }) {
    // const count = preFilteredRows.length
  
    return (
      <div>-</div>
    )
  }
  
  // This is a custom filter UI for selecting
  // a unique option from a list

export function multiSelectFilter(rows, columnIds, filterValue) {
    // Filters only if filters are selected
    return filterValue.length === 0 ? rows : rows.filter((row) => filterValue.includes(String(row.original.status)))
}
export function SelectColumnFilter({
    column: { filterValue, setFilter, preFilteredRows, id, Header },
  }) {
    // Calculate the options for filtering
    // using the preFilteredRows
    const options = React.useMemo(() => {
      const options = new Set()
      preFilteredRows.forEach(row => {
        options.add(row.values[id])
      })
      return [...options.values()]
    }, [id, preFilteredRows])
  
    // Render a multi-select box
    let _option =  ["전체", "검토", "제안보냄",
    "서류합격","최종합격","불합격","기간만료"]

    // console.log(filterValue, setFilter)

    return (
      <div className={"table-filter"}>

        {_option.map((option, i)=>{
          if(option){
            if(option === "전체")
              return(
                <>
                  <input type="radio" name={Header} id={option} value={option} 
                  onChange={(e)=>{ setFilter(undefined)}} />
                  <label htmlFor={option}>{option}</label>
                </>
              )
            else if(option === "검토")
              return(
                <>
                  <input type="radio" name={Header} id={option} value={option} 
                  onChange={(e)=>{setFilter(["지원완료", "추천", "장바구니", "검토"])}} />
                  <label htmlFor={option}>{option}</label>
                </>
              )
            else if(option === "제안보냄")
              return(
                <>
                  <input type="radio" name={Header} id={option} value={option} 
                  onChange={(e)=>{setFilter(["제안보냄", "추천제안"])}} />
                  <label htmlFor={option}>{option}</label>
                </>
              )
            else
              return(
                <>
                  <input type="radio" name={Header} id={option} value={option} 
                  onChange={(e)=>{ setFilter(e.target.value)}} />
                  <label htmlFor={option}>{option}</label>
                </>
              )
          }
        })}
        
      </div>
    )
  }
  
  // This is a custom filter UI that uses a
  // slider to set the filter value between a column's
  // min and max values
function SliderColumnFilter({
    column: { filterValue, setFilter, preFilteredRows, id },
  }) {
    // Calculate the min and max
    // using the preFilteredRows
  
    const [min, max] = React.useMemo(() => {
      let min = preFilteredRows.length ? preFilteredRows[0].values[id] : 0
      let max = preFilteredRows.length ? preFilteredRows[0].values[id] : 0
      preFilteredRows.forEach(row => {
        min = Math.min(row.values[id], min)
        max = Math.max(row.values[id], max)
      })
      return [min, max]
    }, [id, preFilteredRows])
  
    return (
      <>
        <input
          type="range"
          min={min}
          max={max}
          value={filterValue || min}
          onChange={e => {
            setFilter(parseInt(e.target.value, 10))
          }}
        />
        <button onClick={() => setFilter(undefined)}>Off</button>
      </>
    )
  }
  
  // This is a custom UI for our 'between' or number range
  // filter. It uses two number boxes and filters rows to
  // ones that have values between the two
function NumberRangeColumnFilter({
    column: { filterValue = [], preFilteredRows, setFilter, id },
    }) {
    const [min, max] = React.useMemo(() => {
      let min = preFilteredRows.length ? preFilteredRows[0].values[id] : 0
      let max = preFilteredRows.length ? preFilteredRows[0].values[id] : 0
      preFilteredRows.forEach(row => {
        min = Math.min(row.values[id], min)
        max = Math.max(row.values[id], max)
      })
      return [min, max]
    }, [id, preFilteredRows])
  
    return (
      <div
        style={{
          display: 'flex',
        }}
      >
        <input
          value={filterValue[0] || ''}
          type="number"
          onChange={e => {
            const val = e.target.value
            setFilter((old = []) => [val ? parseInt(val, 10) : undefined, old[1]])
          }}
          placeholder={`Min (${min})`}
          style={{
            width: '70px',
            marginRight: '0.5rem',
          }}
        />
        to
        <input
          value={filterValue[1] || ''}
          type="number"
          onChange={e => {
            const val = e.target.value
            setFilter((old = []) => [old[0], val ? parseInt(val, 10) : undefined])
          }}
          placeholder={`Max (${max})`}
          style={{
            width: '70px',
            marginLeft: '0.5rem',
          }}
        />
      </div>
    )
  }
  
function fuzzyTextFilterFn(rows, id, filterValue) {
    return matchSorter(rows, filterValue, { keys: [row => row.values[id]] })
  }
  
  // Let the table remove the filter if the string is empty
  fuzzyTextFilterFn.autoRemove = val => !val


const IndeterminateCheckbox = React.forwardRef(
({ row, indeterminate, ...rest }, ref) => {
    
    const defaultRef = React.useRef()
    const resolvedRef = ref || defaultRef

    // console.log(row)

    React.useEffect(() => {
    resolvedRef.current.indeterminate = indeterminate
    }, [resolvedRef, indeterminate])

    return (<>
      <input id={"exc-" + row} type="checkbox" ref={resolvedRef} {...rest} />
      <label htmlFor={"exc-" + row}></label>
    </>)
}
)
  
export function ColHiding(func, flatColumns){
    return(
        <div id="columns-filter">
            {flatColumns.map((column, index) =>{
                // console.log(column)
                return(
                    <span key={column.id}>
                        {index >=2 ?  
                        <span key={column.id}>
                            {/* <label> */}
                            <input id={"toggle"+column.Header} type="checkbox" {...column.getToggleHiddenProps()} />
                            <label htmlFor={"toggle"+column.Header}>{column.Header} {' '}</label>
                            {/* </label> */}
                        </span>: null}
                    </span>
                    
                )
            })}
            <br />
        </div>
    )
}


const EditableCell = ({
  value: initialValue,
  row: { index },
  column: { id },
  updateMyData, // This is a custom function that we supplied to our table instance
}) => {
  // We need to keep and update the state of the cell normally
  const [value, setValue] = React.useState(initialValue)

  const onChange = e => {
    setValue(e.target.value)
  }

  // We'll only update the external data when the input is blurred
  const onBlur = () => {
    updateMyData(index, id, value)
  }

  // If the initialValue is changed external, sync it up with our state
  React.useEffect(() => {
    setValue(initialValue)
  }, [initialValue])

  return <input value={value} onChange={onChange} onBlur={onBlur} />
}

// Set our editable cell renderer as the default Cell renderer
const defaultColumn = {
  Cell: EditableCell,
}

export function Table({ columns, data, version, windowWidth, dataReset, updateMyData, skipPageReset, raId, cuStatus  }) {
  // Use the state and functions returned from useTable to build your UI
    
// this.setState({ windowWidth, windowHeight });
    // console.log("Table version: " + version)
  const [states, actions] = useContext(UserContext)
  // console.log(states)
  // const [tempemail, setTempemail] = useState()
  // console.log(columns, data)
  const filterTypes = React.useMemo(
    () => ({
      // Add a new fuzzyTextFilterFn filter type.
      fuzzyText: fuzzyTextFilterFn,
      // Or, override the default text filter to use
      // "startWith"
      text: (rows, id, filterValue) => {
        return rows.filter(row => {
          const rowValue = row.values[id]
          return rowValue !== undefined
            ? String(rowValue)
                .toLowerCase()
                .startsWith(String(filterValue).toLowerCase())
            : true
        })
      },
    }),
    []
  )

  const defaultColumn = React.useMemo(
    () => ({
      // Let's set up our default Filter UI
      Filter: RealDefaultColumnFilter,
      // Cell: EditableCell,
    }),
    []
  )

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    state,
    flatColumns,
    preGlobalFilteredRows,
    setGlobalFilter,
    getToggleHideAllColumnsProps,
    selectedFlatRows,
    getToggleRowSelectedProps,
    state: {expanded, selectedRowIds}
  } = useTable({
        columns,
        data,
        filterTypes,
        defaultColumn, // Be sure to pass the defaultColumn option
        
        autoResetPage: !skipPageReset,
        updateMyData,
    },
    
    useFilters, // useFilters!
    useGlobalFilter, // useGlobalFilter!
    useSortBy,
    useExpanded,
    useRowSelect,
    // hooks => {
    //     hooks.flatColumns.push(columns => [
    //         // Let's make a column for selection
    //         {
    //           id: 'selection',
    //           // The header can use the table's getToggleAllRowsSelectedProps method
    //           // to render a checkbox
    //           Header: ({ getToggleAllRowsSelectedProps }) => (
    //             <div>
    //               {/* <IndeterminateCheckbox {...getToggleAllRowsSelectedProps()} /> */}
    //             </div>
    //           ),
    //           // The cell can use the individual row's getToggleRowSelectedProps method
    //           // to the render a checkbox
    //           Cell: ({ row }) => (
    //             <div>
    //               {/* {console.log(selectedFlatRows.length)} */}
    //               <div></div>
    //               <IndeterminateCheckbox row={row.id} {...row.getToggleRowSelectedProps()} />
    //             </div>
    //           ),
    //         },
    //         ...columns,
    //       ])
    // }
  )
//   console.log(version)
//   console.log(data)

// console.log(flatColumns)
// console.log(selectedFlatRows.map(d => d.id))

  // Render the UI for your table
  return (
      <>
        {/* <button id={'transfer-Btn'}
            style={selectedFlatRows.length >=1 ? {opacity: '1'} : {opacity: '.5', cursor: 'not-allowed', }}
            onClick={()=> {
                if (selectedFlatRows.length >=1) 
                    if (window.confirm(selectedFlatRows.map(d => d.original["taskUUID"]) + ' 진짜 옮길거?'))
                        _versionAllSwitch(
                            selectedFlatRows.map(d => d.original["taskUUID"]), 
                            version,
                            dataReset)
                        }}>
                {version? 'Checked data to WJ' : 'Checked data to DEV'}
        </button> */}

        {/* {ColHiding(getToggleHideAllColumnsProps(), flatColumns)} */}
        
        <div id={"table-div"}>
          {flatColumns.map((column, i)=>{
            if(column.Header === "Status")
              return(column.canFilter ? column.render('Filter') : null)
          })}

          <div id ={"table-input"}>
            <GlobalFilter
                preGlobalFilteredRows={preGlobalFilteredRows}
                globalFilter={state.globalFilter}
                setGlobalFilter={setGlobalFilter}
            />

            

          </div>

          
        <table {...getTableProps()}>
        <thead>
            

        </thead>
        

        <tbody {...getTableBodyProps()}>
            {rows.map((row, i) => {
                prepareRow(row);
                return (
                    <React.Fragment {...row.getRowProps()}>
                        <tr >
                          {row.cells.map((cell, index) => {
                            // console.log(cell)
                              if(cell.column.Header === "Email" || 
                              cell.column.Header === "ID" ||
                              cell.column.Header === "Path" ||
                              cell.column.Header === "Profile"){
                                return(<></>)
                              }
                              else if(cell.column.Header === "Position"){
                                return(
                                  <td 
                                    {...cell.getCellProps()}> 
                                    <Link to={
                                      '/recruiter/singleuser/' + 
                                      row.cells[1].value + '/' +  // user id
                                      row.cells[8].value + '/' +  // user which db
                                      raId + '/' +                // ra id
                                      cuStatus
                                    }
                                      onClick={()=>{actions.setTempuser(row.cells[6].value);}}
                                    ></Link>
                                    {cell.value.map((item, index)=>{
                                      return(
                                        <div className={"table-position"}>
                                          {item}
                                        </div>
                                      )
                                    })}
                                    {/* {cell.render('Cell').map((item, index)=>{
                                      return(
                                        <>
                                          {item}
                                        </>
                                      )
                                    })}  */}
                                  </td>
                                )
                              }
                              else if(cell.column.Header === "Name"){
                                console.log(cell)
                                // console.log(row.cells[9].value)
                                // console.log(data.filter(item=>item.email === row.cells[0].value))
                                return(
                                  <td 
                                    {...cell.getCellProps()}> 
                                    <Link to={
                                      '/recruiter/singleuser/' + 
                                      row.cells[1].value + '/' +  // user id
                                      row.cells[8].value + '/' +  // user which db
                                      raId + '/' +                // ra id
                                      cuStatus
                                    }
                                      onClick={()=>{actions.setTempuser(row.cells[6].value);}}
                                      // onClick={actions.}
                                    ></Link>
                                    {/* <header style={{backgroundImage: `url("https://qurator-01.s3.ap-northeast-2.amazonaws.com/static/media/noimage.png")`}}/> */}
                                    <img 
                                      src = {row.cells[9].value ? row.cells[9].value : "dummy"} 
                                      onError={(e)=> {
                                          e.target.src = states.noimage
                                      }}
                                      alt="profile"
                                    />
                                    <div>
                                      <div>
                                        {cell.value ? cell.render('Cell') : "O OO"} 
                                      </div>
                                      <div>
                                        {data.filter(item=>item.email === row.cells[0].value)[0].school ?
                                        data.filter(item=>item.email === row.cells[0].value)[0].school : "없음"} 
                                        {data.filter(item=>item.email === row.cells[0].value)[0].degree}
                                      </div>
                                      {/* <div>
                                        {data.filter(item=>item.email === row.cells[0].value)[0].degree}
                                      </div> */}
                                      <div>
                                        {data.filter(item=>item.email === row.cells[0].value)[0].work ?
                                        data.filter(item=>item.email === row.cells[0].value)[0].work : "없음"}
                                      </div>
                                    </div>
                                  </td>
                                )
                              }
                              else if(cell.column.Header !== "Action"){
                                if(cell.column.Header === "DB"){
                                  return (<></>)
                                }
                                else
                                  return (
                                    <td 
                                      {...cell.getCellProps()}> 
                                      <Link to={
                                      '/recruiter/singleuser/' + 
                                      row.cells[1].value + '/' +  // user id
                                      row.cells[8].value + '/' +  // user which db
                                      raId + '/' +                // ra id
                                      cuStatus
                                    }
                                      onClick={()=>{actions.setTempuser(row.cells[6].value);}}
                                      // onClick={actions.}
                                    ></Link>
                                      {cell.render('Cell')} 
                                    </td>
                                  )
                              }
                              else
                                return (
                                  <td 
                                    {...cell.getCellProps()}>
                                    {cell.render('Cell')} 
                                  </td>
                                )
                          })}
                        </tr>
                    </React.Fragment>
                )}
            )}
        </tbody>
        </table>
        </div>
        {/* <p>Selected Rows: {Object.keys(selectedRowIds).length}</p> */}
        
    </>
  )
}

function _handleScroll(e){

}


export function TableApp(props) {
    // console.log(tableData)
    // console.log(versionBool)
    let windowWidth = typeof window !== "undefined" ? window.innerWidth : 0;
    let windowHeight = typeof window !== "undefined" ? window.innerHeight : 0;



    if(windowWidth >= 768){
    }
    else{
    }

    
    const columns = React.useMemo(
    () => 
        [
            {
                Header: ' ',
                columns: props.columns
            },
        ],
    )
    
  const newData = React.useMemo(() => props.data)
  const [data, setData] = React.useState(()=> props.data)
  const [originalData] = React.useState(data)
  const [skipPageReset, setSkipPageReset] = React.useState(false)

  const [state, actions] = useContext(UserContext);

  const updateMyData = (rowIndex, columnId, value) => {
    // We also turn on the flag to not reset the page
    setSkipPageReset(true)
    setData(old =>
      old.map((row, index) => {
        if (index === rowIndex) {
          return {
            ...old[rowIndex],
            [columnId]: value,
          }
        }
        return row
      })
    )
  }

  React.useEffect(() => {
    setSkipPageReset(false)
  }, [data])

  const resetData = () => setData(originalData)

  // console.log(data)

  return (
      
    // <Styles className={props ? "visible" : "hidden"}>
    <Styles>
      <div>
        <Table  
            columns={props.columns} 
            data={props.data} 
            version={props.versionBool} 
            windowWidth={windowWidth}
            dataReset={props.dataReset}
            // renderRowSubComponent={renderRowSubComponent}
            // updateMyData={updateMyData}
            skipPageReset={skipPageReset}
            raId = {props.currentId}
            cuStatus = {props.currentStatus}
            
        />
        </div>
         
    </Styles>
  )
}

// export default TestApp